import { peng2018DiseaseMap } from '../shared.constants';
import { roundToPrecision } from './utilFunctions';

function getBmiCategory(bmi) {
  if (bmi <= 18.5) return 'underweight';
  if (bmi > 18.5 && bmi <= 30) return 'normal';
  return 'overweight';
}

function getAgeCategory(age) {
  return age <= 65 ? 'below65' : 'above65';
}

export function getDiseaseOptions(bmi, age) {
  // 1) Quick check: if empty or invalid, return empty
  if (!bmi || !age) return [];

  const numericBmi = parseFloat(bmi);
  const numericAge = parseInt(age, 10);

  if (isNaN(numericBmi) || isNaN(numericAge)) {
    return [];
  }

  // 2) Determine BMI & Age categories
  const bmiCategory = getBmiCategory(numericBmi); // 'underweight' | 'normal' | 'overweight'
  const ageCategory = getAgeCategory(numericAge); // 'below65' | 'above65'

  // 3) Construct a key & retrieve matching array from the map
  const key = `${bmiCategory}_${ageCategory}`;
  return peng2018DiseaseMap[key] || [];
}

export function getOtherValues({ bmi, age, weight, height, gender }) {
  const numericBmi = parseFloat(bmi);
  const numericAge = parseInt(age, 10);
  const numericWeight = parseFloat(weight);
  const numericHeight = parseFloat(height);

  if (Number.isNaN(numericBmi) || Number.isNaN(numericAge)) {
    return [];
  }

  // 1) If BMI <= 18.5 => store [25, 30]
  if (numericBmi <= 18.5) {
    return [25, 30];
  }

  // 2) If 18.5 <= BMI <= 30 => store [20, 25]
  if (numericBmi <= 30) {
    return [20, 25];
  }

  // 3) If BMI > 30 => formula-based for male & female
  //    The formula is:
  //      - male:   10 * weight + 6.25 * height - 5 * age + 5
  //      - female: 10 * weight + 6.25 * height - 5 * age - 161

  // (a) Make sure weight/height are valid
  if (Number.isNaN(numericWeight) || Number.isNaN(numericHeight)) {
    return []; // or handle error differently
  }

  // (b) We'll compute maleValue & femaleValue

  if (gender.toLowerCase() === 'male') {
    const maleValue =
      10 * numericWeight + 6.25 * numericHeight - 5 * numericAge + 5;

    return [maleValue];
  }

  if (gender.toLowerCase() === 'female') {
    const femaleValue =
      10 * numericWeight + 6.25 * numericHeight - 5 * numericAge - 161;
    return [femaleValue];
  }
}

export function getReePlusPal(reeArr: number[], activityFactor: number) {
  if (activityFactor) {
    return reeArr.map((ree) => {
      const val = Number(ree) * activityFactor;
      // If val is an integer, return it as is; otherwise return two decimals.
      // return Number.isInteger(val) ? String(val) : val.toFixed(2);
      return roundToPrecision(val);
    });
  } else {
    return reeArr;
  }
}
